const CctlCell = ({ project }) => {
  const { assigned_lab } = project;
  if (!assigned_lab.name) return null;

  return <span>{project.assigned_lab.name}</span>;
};
export default CctlCell;
